interface ProgressBarProps {
    value: number
    max: number
    className?: string
    color?: string
    backgroundColor?: string
    height?: string
    showValue?: boolean
    label?: string
  }
  
  export default function ProgressBar({
    value,
    max,
    className = "",
    color = "bg-blue-500",
    backgroundColor = "bg-gray-200",
    height = "h-2",
    showValue = false,
    label,
  }: ProgressBarProps) {
    // Calculate percentage
    const percentage = Math.min(100, Math.max(0, (value / max) * 100))
  
    return (
      <div className={`w-full ${className}`}>
        {label && (
          <div className="flex justify-between mb-1">
            <span className="text-sm font-medium text-gray-700">{label}</span>
            {showValue && (
              <span className="text-sm font-medium text-gray-500">
                {value}/{max}
              </span>
            )}
          </div>
        )}
        <div className={`w-full ${backgroundColor} rounded-full ${height} overflow-hidden`}>
          <div
            className={`${color} rounded-full ${height} transition-all duration-300 ease-in-out`}
            style={{ width: `${percentage}%` }}
            role="progressbar"
            aria-valuenow={value}
            aria-valuemin={0}
            aria-valuemax={max}
            aria-label={label || "Progress"}
          />
        </div>
        {showValue && !label && <div className="mt-1 text-xs text-right text-gray-500">{percentage.toFixed(0)}%</div>}
      </div>
    )
  }